import { useEffect, useState } from 'react';
import { apiFetch } from '../../api';
import Layout from '../../layouts/Layout';
import './Users.css';

export default function Users() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [editForm, setEditForm] = useState({
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        role: 'user',
        status: 'active',
    });
    useEffect(() => {
        fetchUsers();
    }, []);

  /* ---------------- FETCH USERS ---------------- */
    const fetchUsers = async () => {
        try {
        const data = await apiFetch('/api/user-details/get-users');
        setUsers(data);
        } catch (err) {
        console.error('Failed to load users', err);
        } finally {
        setLoading(false);
        }
    };

  /* ---------------- FORM CHANGE ---------------- */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditForm(prev => ({
        ...prev,
        [name]: value,
        }));
    };

  /* ---------------- OPEN EDIT MODAL ---------------- */
    const openUserModal = async (userId) => {
        setShowModal(true);
        setIsEditing(false);
        setDetailsLoading(true);
        try {
            const data = await apiFetch(
                `/api/user-details/get-user-details?userId=${userId}`
            );

            setUserDetails(data);
            setEditForm({
                username: data.username || '',
                firstname: data.firstname || '',
                lastname: data.lastname || '',
                email: data.email || '',
                password: '',
                role: data.role || 'user',
                status: data.status || 'active',
            });
        } catch (err) {
            console.error('Failed to load user details', err);
        } finally {
            setDetailsLoading(false);
        }
    };

    /* ---------------- ADD USER ---------------- */
    const openAddUserModal = () => {
        setShowModal(true);
        setIsEditing(true);
        setUserDetails(null);
        setEditForm({
            username: '',
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            role: 'user',
            status: 'active',
        });
    };

    /* ---------------- SAVE USER ---------------- */
    const saveUserDetails = async () => {
        try {
        await apiFetch('/api/user-details/update-user', {
            method: 'POST',
            body: JSON.stringify({
            ...editForm,
            userId: userDetails?.id || null,
            }),
        });
        closeModal();
        fetchUsers();
        } catch (err) {
            console.error('Failed to save user', err);
        }
    };

    /* ---------------- CLOSE MODAL ---------------- */
    const closeModal = () => {
        setShowModal(false);
        setUserDetails(null);
        setIsEditing(false);
    };

    if (loading) return <h2>Loading users...</h2>;

    return (
        <Layout>
        {/* HEADER */}
        <div className="users-toolbar">
            <div>
            <h1 className="users-title">Users</h1>
            <p className="users-subtitle">Manage application users</p>
            </div>
            <button className="add-user-btn" onClick={openAddUserModal}>
            + Add User
            </button>
        </div>
        {/* USER CARDS */}
        <div className="users-grid">
            {users.map(user => (
            <div
                className="user-card"
                key={user.id}
                onClick={() => openUserModal(user.id)}
            >
                <div className="user-avatar">
                {user.username.charAt(0).toUpperCase()}
                </div>
                <div className="user-info">
                <div className="user-name">{user.username}</div>
                <div className="user-role">
                    {user.firstname} {user.lastname}
                </div>
                </div>
            </div>
            ))}
        </div>
        {/* MODAL */}
        {showModal && (
            <div className="modal-overlay" onClick={closeModal}>
            <div className="modal" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={closeModal}>✕</button>
                {detailsLoading ? (
                <p>Loading...</p>
                ) : (
                <>
                    <h2 className="modal-title">
                    {userDetails ? 'User Details' : 'Add User'}
                    </h2>
                    {isEditing ? (
                    <div className="edit-form">
                        <label>
                        Username
                        <input name="username" value={editForm.username} onChange={handleChange} />
                        </label>
                        <label>
                            Password
                            <input
                                type="password"
                                name="password"
                                value={editForm.password}
                                onChange={handleChange}
                                placeholder={userDetails ? 'Leave blank to keep unchanged' : 'Enter password'}
                            />
                        </label>
                        <label>
                        First Name
                        <input name="firstname" value={editForm.firstname} onChange={handleChange} />
                        </label>
                        <label>
                        Last Name
                        <input name="lastname" value={editForm.lastname} onChange={handleChange} />
                        </label>
                        <label>
                        Email
                        <input name="email" value={editForm.email} onChange={handleChange} />
                        </label>
                        <label>
                        Role
                        <select name="role" value={editForm.role} onChange={handleChange}>
                            <option value="admin">Admin</option>
                            <option value="user">User</option>
                        </select>
                        </label>
                        <label>
                        Status
                        <select name="status" value={editForm.status} onChange={handleChange}>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                        </label>
                        <div className="modal-actions">
                        <button className="btn-primary" onClick={saveUserDetails}>Save</button>
                        <button className="btn-secondary" onClick={closeModal}>Cancel</button>
                        </div>
                    </div>
                    ) : (
                    <>
                        <p><strong>Name:</strong> {userDetails.firstname} {userDetails.lastname}</p>
                        <p><strong>Email:</strong> {userDetails.email}</p>
                        <p><strong>Role:</strong> {userDetails.role}</p>
                        <p><strong>Status:</strong> {userDetails.status}</p>
                        <button className="btn-primary" onClick={() => setIsEditing(true)}>
                        Edit User
                        </button>
                    </>
                    )}
                </>
                )}
            </div>
            </div>
        )}
        </Layout>
    );
}
